function getByteLen(val) {
    var len = 0;
    for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/ig) != null) {//\x00-\xff→GBK双字节编码范围
            len += 2;
        }
        else {
            len += 1;
        }
    }
    return len;
}
class FormCheck {
    constructor($mod, checkItems) {
        this.$mod = $mod;
        this.checkItems = checkItems;
        this.formItems = {};
    }
    cityCheck(container) {
        let $dataArea = this.$mod.find(container);
        let provinceId = $dataArea.attr('province_id');
        let provinceName = $dataArea.attr('province_name');
        let cityId = $dataArea.attr('city_id');
        let cityName = $dataArea.attr('city_name');
        let quxianId = $dataArea.attr('quxian_id');
        let quxianName = $dataArea.attr('quxian_name');
        let areaName = $dataArea.find('.text-info').text();

        if (cityId && areaName) {
            this.formItems.areaCode = cityId;
            this.formItems.areaName = areaName;

            return true;
        } else {

            $dataArea.find('.lpbm-input-warn').show(100).delay(2000).fadeOut(200);

            return false;
        }
    }
    areaCheck(container) {
        let $dataArea = this.$mod.find(container);
        let area = $dataArea.val();
        let $errorArea = $dataArea.parent().find('.lpbm-input-warn');
        let errorText = '请输入房屋面积';
        if (area && area != $dataArea.data('placeholder')) {
            let floatArea = parseFloat(area);
            if (floatArea) {
                let pointInfo = floatArea.toString().split(".");
                if (pointInfo.length < 2 || pointInfo.length == 2 && pointInfo[1].length <= 2) {
                    if (parseInt(area) >= 30 && parseInt(area) <= 200) {
                        this.formItems.area = floatArea;
                        return true;
                    } else {
                        errorText = '面积需在30-200㎡之间';
                    }
                } else {
                    errorText = '面积不能超过2位小数';
                }
            } else {
                errorText = '请输入2位小数内的阿拉伯数字';
            }
        }

        $errorArea.find('.error-text').text(errorText);
        $errorArea.show(100).delay(2000).fadeOut(200);
        return false;
    }

    mobileCheck(container) {
        let $dataArea = this.$mod.find(container);
        let mobile = $dataArea.val();
        let errorText = '请输入您的手机号码';
        let $errorArea = $dataArea.parent().find('.lpbm-input-warn');
        if (mobile && mobile != $dataArea.data('placeholder')) {
			if (/^1[3456789]\d{9}$/.test(mobile)) {
            // if (mobile.toString().length == 11 && mobile.charAt(0) == '1') {
                this.formItems.mobile = mobile;
                return true;
            } else {
                errorText = '请输入正确的手机号码';
            }
        }

        $errorArea.find('.error-text').text(errorText);
        $errorArea.show(100).delay(2000).fadeOut(200);
        return false;
    }

    nameCheck(container) {
        let $dataArea = this.$mod.find(container);
        let name = $dataArea.val() || '';
        let errorText = '请输入您的称呼';
        let $errorArea = $dataArea.parent().find('.lpbm-input-warn');
        if (name && getByteLen(name) <= 24 && name != $dataArea.data('placeholder')) {
            this.formItems.name = name;
            return true;
        } else if (getByteLen(name) > 24) {
            errorText = '称呼不超过24个字符';
        }

        $errorArea.find('.error-text').text(errorText);
        $errorArea.show(100).delay(2000).fadeOut(200);
        return false;
    }

    clauseCheck(container) {
        let $dataArea = this.$mod.find(container);
        let $errorArea = $dataArea.parent().find('.lpbm-input-warn');
        if ($dataArea.hasClass('active')) {
            return true;
        } 
        $errorArea.show(100).delay(2000).fadeOut(200);
        return false;
    }

    check() {
        this.formItems = {};
        let checkresult;
        for (let i=0; i< this.checkItems.length; i++) {
            if (this.checkItems[i].name == 'name') {
                checkresult = this.nameCheck(this.checkItems[i].container);
            } else if (this.checkItems[i].name == 'city') {
                checkresult = this.cityCheck(this.checkItems[i].container);
            } else if (this.checkItems[i].name == 'area') {
                checkresult = this.areaCheck(this.checkItems[i].container);
            } else if (this.checkItems[i].name == 'mobile') {
                checkresult = this.mobileCheck(this.checkItems[i].container);
            } else if (this.checkItems[i].name == 'clause') {
                checkresult = this.clauseCheck(this.checkItems[i].container);
            }
            if (!checkresult) {
                return false;
            }
        }
        return this.formItems;
    }
    
}

export default FormCheck;


// WEBPACK FOOTER //
// ./src/module/home-index/home-toutiao/formCheck.js